import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import classname from 'classnames';

//i18n
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import roleAccess from 'components/Common/roleAccess';
import allInternalTraxaaRolesData from 'constants/allRoles';
import { invoiceScreenAccess } from 'constants/pageAccessRole';

const Navbar = props => {
	const [getDashboard, setdashboard] = useState(false);
	const [getBookings, setBookings] = useState(false);
	const [getInvoices, setInvoices] = useState(false);
	const [getTraxaaClients, setTraxaaClients] = useState(false);
	const [getDocuments, setDocuments] = useState(false);
	const [getCustomers, setCustomers] = useState(false);
	const [getShippingLines, setShippingLines] = useState(false);
	const [getAgents, setAgents] = useState(false);
	const [getWorkflows, setWorkFlows] = useState(false);

	const UserProperties = createSelector(
		state => state.Login,
		loginData => ({
			userData: loginData.userData
		})
	);

	const { userData } = useSelector(UserProperties);

	useEffect(() => {
		var matchingMenuItem = null;
		var ul = document.getElementById('navigation');
		var items = ul.getElementsByTagName('a');
		removeActivation(items);
		for (var i = 0; i < items.length; ++i) {
			if (window.location.pathname === items[i].pathname) {
				matchingMenuItem = items[i];
				break;
			}
		}
		if (matchingMenuItem) {
			activateParentDropdown(matchingMenuItem);
		}
	});

	const removeActivation = items => {
		for (var i = 0; i < items.length; ++i) {
			var item = items[i];
			const parent = items[i].parentElement;
			if (item && item.classList.contains('active')) {
				item.classList.remove('active');
			}
			if (parent) {
				if (parent.classList.contains('active')) {
					parent.classList.remove('active');
				}
			}
		}
	};

	function activateParentDropdown(item) {
		item.classList.add('active');
		const parent = item.parentElement;
		if (parent) {
			parent.classList.add('active'); // li
			const parent2 = parent.parentElement;
			parent2.classList.add('active'); // li
			const parent3 = parent2.parentElement;
			if (parent3) {
				parent3.classList.add('active'); // li
				const parent4 = parent3.parentElement;
				if (parent4) {
					parent4.classList.add('active'); // li
					const parent5 = parent4.parentElement;
					if (parent5) {
						parent5.classList.add('active'); // li
						const parent6 = parent5.parentElement;
						if (parent6) {
							parent6.classList.add('active'); // li
						}
					}
				}
			}
		}
		return false;
	}

	return (
		<React.Fragment>
			<div className="topnav">
				<div className="container-fluid">
					<nav className="navbar navbar-light navbar-expand-lg topnav-menu" id="navigation">
						<Collapse isOpen={props.leftMenu} className="navbar-collapse" id="topnav-menu-content">
							<ul className="navbar-nav">
								<li className="nav-item dropdown">
									<Link className="nav-link dropdown-toggle arrow-none font-size-12" to="/dashboard">
										<i className="bx bx-home-circle me-2"></i>
										{props.t('Dashboard')} {props.menuOpen}
									</Link>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={e => {
											e.preventDefault();
											setBookings(!getBookings);
										}}
										className="nav-link dropdown-toggle arrow-none font-size-12"
									>
										<i className="bx bxs-purchase-tag me-2"></i>
										{props.t('Quotations')} <div className="arrow-down"></div>
									</Link>
									<div className={classname('dropdown-menu', { show: getBookings })}>
										{userData && roleAccess(userData?.role, [...allInternalTraxaaRolesData]) && (
											<>
												<Link to="/all-quotations" onClick={() => setBookings(false)} className="dropdown-item">
													{props.t('All Quotes')}
												</Link>
												<Link to="/contract-rates" onClick={() => setBookings(false)} className="dropdown-item">
													{props.t('Contract Rates')}
												</Link>
											</>
										)}
									</div>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={e => {
											e.preventDefault();
											setBookings(!getBookings);
										}}
										className="nav-link dropdown-toggle arrow-none font-size-12"
									>
										<i className="bx bxs-book-content me-2"></i>
										{props.t('Bookings')} <div className="arrow-down"></div>
									</Link>
									<div className={classname('dropdown-menu', { show: getBookings })}>
										{userData && roleAccess(userData?.role, [...allInternalTraxaaRolesData]) ? (
											<>
												<Link to="/bookings" onClick={() => setBookings(false)} className="dropdown-item">
													{props.t('All Bookings')}
												</Link>
											</>
										) : (
											<Link to="/bookings" className="dropdown-item">
												{props.t('All Bookings')}
											</Link>
										)}
									</div>
								</li>

								{userData && roleAccess(userData?.role, [...invoiceScreenAccess]) ? (
									<li className="nav-item dropdown">
										<Link
											to="/#"
											onClick={e => {
												e.preventDefault();
												//setInvoices(!getInvoices);
											}}
											className="nav-link dropdown-toggle arrow-none font-size-12"
										>
											<i className="bx bx-customize me-2"></i>
											{props.t('Invoices')} <div className="arrow-down"></div>
										</Link>
										<div className={classname('dropdown-menu', { show: getInvoices })}>
											<Link to="/invoices" onClick={() => setInvoices(false)} className="dropdown-item">
												{props.t('All Invoices')}
											</Link>
											<Link to="/due-invoices" onClick={() => setInvoices(false)} className="dropdown-item">
												{props.t('Due Invoices')}
											</Link>
										</div>
									</li>
								) : null}
							</ul>
						</Collapse>
					</nav>
				</div>
			</div>
		</React.Fragment>
	);
};

Navbar.propTypes = {
	leftMenu: PropTypes.any,
	location: PropTypes.any,
	menuOpen: PropTypes.any,
	t: PropTypes.any
};

const mapStatetoProps = state => {
	const { leftMenu } = state.Layout;
	return { leftMenu };
};

export default withRouter(connect(mapStatetoProps, {})(withTranslation()(Navbar)));
